<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail jxxf-plan-detail"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        查看计划详情
      </h2>
      <div class="c-page__header-btns">
        <k-button
          v-if="detail.jhzt === 'DSC'"
          btn-text="预览当前报告"
          :auth-type="false"
          type="primary"
          plain
          @click="handlePreview($event)"
        />
        <k-button
          v-if="detail.jhzt === 'DSC'"
          btn-text="生成正式报告"
          :auth-type="false"
          type="primary"
          plain
          @click="handleFormal"
        />
        <k-button
          v-if="detail.jhzt === 'DGZ' && detail.wgzfjId && !detail.gzfjId"
          btn-text="上传盖章报告"
          :auth-type="false"
          type="primary"
          plain
          @click="openUpload"
        />
        <k-button
          v-if="detail.jhzt === 'DGZ'"
          btn-text="申请修改"
          :auth-type="false"
          type="warning"
          plain
          @click="handleModification"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeDetail"
        />
      </div>
    </div>
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card-detail">
        <div class="o-tips u-mg-b-10">
          <div class="o-tips__title">
            说明:
          </div>
          <ul class="o-tips__body">
            <li class="o-tips__item">
              所有维保内容须填写完整后，才可生成维保报告。
            </li>
            <li class="o-tips__item">
              生成报告后如需修改，请使用计划管理中的重新修改功能。
            </li>
          </ul>
        </div>
        <div class="o-part-title">
          维保计划
        </div>
        <el-form
          class="c-form"
          :model="detail"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
              >
                <span class="c-form__read">{{ detail.xmmc || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="计划维保时间"
              >
                <span class="c-form__read">{{ formatDate(detail.jhsjQ) }} 至 {{ formatDate(detail.jhsjZ) }}（{{ detail.jhlxMc || '-' }}）</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
              >
                <span class="c-form__read">{{ detail.jhmc || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目负责人"
              >
                <span class="c-form__read">{{ detail.xmfzrMc || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="技术负责人"
              >
                <span class="c-form__read">{{ detail.jsfzrMc || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="维保人员"
              >
                <span class="c-form__read">{{ memberNames || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="维保内容"
              >
                <span class="c-form__read">{{ contentNames || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="任务描述"
              >
                <span class="c-form__read">{{ detail.rwms || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="维保报告"
              >
                <span class="c-form__read">{{ detail.bgztMc || reportStatusText }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="o-part-title">
          维保系统
        </div>
        <el-table
          class="c-page__table o-header-text-center"
          stripe
          border
          :data="systemRows"
        >
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          />
          <el-table-column
            prop="ssmc"
            label="系统名称"
            min-width="220"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="openSystemDialog(scope.row)"
              >
                {{ scope.row.ssmc }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="检测项数量"
            min-width="180"
          />
          <el-table-column
            prop="completed"
            label="已完成数量"
            min-width="180"
          />
          <el-table-column
            prop="pending"
            label="未完成数量"
            min-width="180"
          />
        </el-table>
      </hm-page-card>
    </div>
    <el-dialog
      :title="selectedSystem.ssmc ? selectedSystem.ssmc + '维保内容' : '维保内容'"
      :visible.sync="systemDialogVisible"
      width="900px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-table
        :data="selectedSystem.items || []"
        border
        stripe
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
        />
        <el-table-column
          prop="wblx"
          label="要求类型"
          width="120"
        />
        <el-table-column
          prop="wbbh"
          label="维保编号"
          width="140"
        />
        <el-table-column
          prop="zqdm"
          label="周期"
          width="80"
          align="center"
        />
        <el-table-column
          prop="wbnr"
          label="测试/维保内容"
          min-width="480"
          show-overflow-tooltip
        />
      </el-table>
      <div
        slot="footer"
        class="o-dialog__footer"
      >
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="systemDialogVisible = false"
        />
      </div>
    </el-dialog>
    <el-dialog
      title="上传签字盖章报告"
      :visible.sync="uploadDialogVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetUploadDialog"
    >
      <el-form label-width="100px">
        <el-form-item label="报告编号">
          <span>{{ detail.bgbh || '-' }}</span>
        </el-form-item>
        <el-form-item
          label="报告文件"
          required
        >
          <file-serve-upload
            ref="sealedReportUpload"
            v-model="uploadFileId"
            :file-api="$config.ctx.hmfileApi"
            show-file-list
            accept="application/pdf,.pdf"
            :format="['pdf', 'PDF']"
            :data="uploadFd"
            :max-size="30 * 1024"
          >
            <k-button
              btn-text="选择 PDF"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-cloud-upload"
              plain
            />
          </file-serve-upload>
          <span class="u-text-warning">（仅支持 PDF，最大 30M）</span>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="o-dialog__footer"
      >
        <k-button
          btn-text="保存"
          :auth-type="false"
          type="primary"
          :loading="uploadSubmitting"
          :disabled="!uploadFileId"
          @click="submitUpload"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          :disabled="uploadSubmitting"
          @click="uploadDialogVisible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { planService } from './plan.service';
import { reportService } from '../report/report.service';

export default {
  name: 'JxxfWbPlanDetail',
  data () {
    return {
      loading: false,
      systemDialogVisible: false,
      selectedSystem: { ssmc: '', items: [] },
      uploadDialogVisible: false,
      uploadFileId: null,
      uploadSubmitting: false,
      uploadFd: { meta: [{ key: 'jxxf_wb_sealed_report', value: 'Y' }] },
      detail: { ryList: [], nrList: [] }
    };
  },
  computed: {
    /** 拼接计划维保人员名称。 */
    memberNames () {
      return (this.detail.ryList || []).map(item => item.rymc || item.ryDm).join('、');
    },
    /** 拼接计划维保系统内容名称。 */
    contentNames () {
      return (this.detail.nrList || []).map(item => item.ssmc).filter((item, index, list) => item && list.indexOf(item) === index).join('；');
    },
    /** 将内容快照按设施系统汇总为广东详情页的统计表。 */
    systemRows () {
      const groups = {};
      (this.detail.ssflList || []).forEach(item => {
        groups[item.uuid] = { ssflId: item.uuid, ssmc: item.ssmc, total: 0, completed: 0, pending: 0, items: [] };
      });
      (this.detail.nrList || []).forEach(item => {
        if (!groups[item.ssflId]) groups[item.ssflId] = { ssflId: item.ssflId, ssmc: item.ssmc, total: 0, completed: 0, pending: 0, items: [] };
        groups[item.ssflId].total += 1;
        if (item.completed === 'Y') {
          groups[item.ssflId].completed += 1;
        } else {
          groups[item.ssflId].pending += 1;
        }
        groups[item.ssflId].items.push(item);
      });
      return Object.keys(groups).map(key => groups[key]);
    },
    reportStatusText () {
      const statusMap = {
        WKS: '暂无报告',
        ZXZ: '暂无报告',
        DSC: '待生成报告',
        DGZ: '待盖章',
        YWC: '已完成'
      };
      return statusMap[this.detail.jhzt] || '-';
    }
  },
  methods: {
    /** 加载维保计划详情。 */
    loadDetail () {
      this.loading = true;
      planService.detail(this.$route.params.id).then(rsp => {
        this.detail = rsp.data || { ryList: [], nrList: [] };
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 关闭当前计划详情页并返回项目计划列表。 */
    closeDetail () {
      this.closeNavTabAndTo({ name: 'jxxfWbPlanProjectList', params: { xmId: this.detail.xmId } });
    },
    /** 打开指定设施系统的维保内容列表弹窗。 */
    openSystemDialog (system) {
      this.selectedSystem = system;
      this.systemDialogVisible = true;
    },
    /** 显示报告操作结果并返回数据，供预览下载和状态刷新复用。 */
    showReportActionResult (rsp) {
      const result = rsp.data && rsp.data.data;
      this.$message.success(result && result.message ? result.message : '报告操作完成');
      return result;
    },
    /** 与广东维保一致：通过统一预览工具下载 PDF Blob 后在新标签页打开。 */
    handlePreview (event) {
      // 预览接口是异步请求，原始 Event.currentTarget 在 Promise 回调中会变成 null；
      // 先保存触发按钮 DOM，避免预览工具取不到 Vue 实例而触发第二个“失败”提示。
      const trigger = (event && event.currentTarget) || this.$el;
      // 自定义按钮未暴露 __vue__ 时，回退到当前详情页实例。
      const previewTarget = { __vue__: (trigger && trigger.__vue__) || this };
      this.loading = true;
      reportService.preview(this.detail.uuid || this.$route.params.id).then(rsp => {
        const result = this.showReportActionResult(rsp);
        if (result && result.fileId) {
          this.$utils.previewPdf({ currentTarget: previewTarget }, result.fileId, this.detail);
          return;
        }
        this.$message.error('预览报告文件生成失败');
      }).catch(() => {
        this.$message.error('预览报告生成失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleFormal () {
      this.$confirm('正式生成后计划将进入待盖章状态，是否继续？', '生成正式报告', {
        type: 'warning'
      }).then(() => {
        this.loading = true;
        return reportService.formal(this.detail.uuid || this.$route.params.id).then(rsp => {
          this.showReportActionResult(rsp);
          this.loadDetail();
        }).catch(() => {
          this.$message.error('正式报告生成失败');
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },
    openUpload () {
      this.uploadFileId = null;
      this.uploadSubmitting = false;
      this.uploadDialogVisible = true;
    },
    resetUploadDialog () {
      if (this.$refs.sealedReportUpload) this.$refs.sealedReportUpload.clearFiles();
      this.uploadDialogVisible = false;
      this.uploadFileId = null;
      this.uploadSubmitting = false;
    },
    submitUpload () {
      if (!this.uploadFileId) {
        this.$message.warning('请先选择签字盖章报告文件');
        return;
      }
      this.uploadSubmitting = true;
      reportService.uploadSealedReport(
        this.detail.uuid || this.$route.params.id,
        { fileId: this.uploadFileId }
      ).then(rsp => {
        this.showReportActionResult(rsp);
        this.uploadDialogVisible = false;
        this.loadDetail();
      }).catch(() => {}).finally(() => {
        this.uploadSubmitting = false;
      });
    },
    handleModification () {
      this.$prompt('请输入申请修改原因', '申请修改', {
        inputPlaceholder: '请输入申请修改原因',
        inputValidator: value => value && value.trim() ? true : '申请修改原因不能为空',
        inputErrorMessage: '申请修改原因不能为空'
      }).then(({ value }) => {
        return reportService.requestModification(
          this.detail.uuid || this.$route.params.id,
          { reason: value }
        ).then(rsp => {
          this.showReportActionResult(rsp);
          this.loadDetail();
        });
      }).catch(() => {});
    },
    /** 格式化秒级或毫秒级时间戳。 */
    formatDate (value) {
      if (value === null || value === undefined || value === '') return '-';
      const raw = Number(value);
      const date = Number.isFinite(raw) ? new Date(raw < 100000000000 ? raw * 1000 : raw) : new Date(String(value).replace(/-/g, '/'));
      if (Number.isNaN(date.getTime())) return '-';
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    }
  },
  created () {
    this.loadDetail();
  }
};
</script>
